import { useEffect } from 'react';
import { StoreCode, storeCodeSchema } from '../schema/storeCode';
import { useCloudfrontLocationQuery } from '../state/hooks/useCloudfrontLocation';
import { useStoreValue } from '../state/hooks/useStore';
import { setUserLocation } from './events/user';

const stores = storeCodeSchema.options as StoreCode[];

export const useUserTracking = () => {
  // Set up the store flags. These are used by third party tags.
  const store = useStoreValue();

  useEffect(() => {
    stores.forEach((flag) => {
      window[`is_${flag}_store`] = false;
    });

    window[`is_${store}_store`] = true;
  }, [store]);

  // Send an analytics event for the user location.
  const { data } = useCloudfrontLocationQuery();

  useEffect(() => {
    if (!data) return;
    setUserLocation({ location: data });
  }, [data]);
};
